import { render, staticRenderFns } from "./OutilsItem.vue?vue&type=template&id=7538e1bc&scoped=true&"
import script from "./OutilsItem.vue?vue&type=script&lang=ts&"
export * from "./OutilsItem.vue?vue&type=script&lang=ts&"
import style0 from "./OutilsItem.vue?vue&type=style&index=0&id=7538e1bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7538e1bc",
  null
  
)

export default component.exports